import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const DownloadButton = ({ fileUrl }) =>
  <Button className="pull-right" bsStyle="primary" bsSize="xs" href={fileUrl} target="_blank">
    <i className="fa fa-download" /> Stáhnout
  </Button>;

DownloadButton.propTypes = {
  fileUrl: PropTypes.string.isRequired
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/browser/Feature/downloads/download_button.jsx